<div class="bg-white">
    <h2 class="settings-header px-4 pt-5 pb-3 mb-0">{{'yearly_billing.details.title' | translate}}</h2>

    <div class="px-4 pb-3 pt-3 bg-grey">
        <div class="row py-2 billing-information">
            @if(loading()){
            <p><i class="fa-3x fa-solid fa-sync fa-spin"></i></p>
            } @else {
            <table class="table table-striped table-hover" matSort (matSortChange)="sortData($event)" matSortActive="creationDate" matSortDirection="asc">
                <thead>
                    <tr>
                        <th mat-sort-header="name">{{'yearly_billing.details.team_name' | translate}}</th>
                        <th mat-sort-header="creationDate">{{'yearly_billing.details.creation_date' | translate}}</th>
                        <th mat-sort-header="creator">{{'yearly_billing.details.creator' | translate}}</th>
                        <th>
                            <mat-select class="form-select" [formControl]="monthsCtrl">
                                @for (month of months; track month) {
                                    <mat-option [value]="month">{{ month.label }}</mat-option>
                                }
                            </mat-select>
                        </th>
                        <th>{{'yearly_billing.details.current_size' | translate}}</th>
                    </tr>
                </thead>

                <tbody>
                @for (team of teamsDetails(); track team) {
                    <tr>
                        <td>@if(team.currentMonthUsage.count > 0) {
                            <a [routerLink]="['/setup/teammembers', team.id]" target="_blank">{{team.name}}</a>
                        } @else {
                            {{team.name}}
                        }
                        </td>
                        <td>{{team.creationDate | date: 'mediumDate'}}</td>
                        <td>{{team.creator}}</td>
                        <td style="text-align: center;">{{team.selectedMonthUsage}}</td>
                        <td style="text-align: center;">{{team.currentMonthUsage.count}}
                            <licence-usage-with-diff [licenceUsageWithDiff]="team.currentMonthUsage"/>
                        </td>
                    </tr>
                }
                </tbody>
                <tfoot>
                    <tr style="font-weight: bold">
                        <td colspan="3" style="text-align: right;">Total <i class="fal fa-circle-info" matTooltip="{{'yearly_billing.details.totalUniques' | translate}}"></i></td>
                        <td style="text-align: center;">{{ totalSelectedMonth() }}</td>
                        <td style="text-align: center;">{{ totalCurrentMonth().count }} <licence-usage-with-diff [licenceUsageWithDiff]="totalCurrentMonth()"/></td>
                    </tr>
                </tfoot>
            </table>
            }
        </div>
        <div class="row py-2 billing-information">

            <p><button class="btn btn-primary" routerLink="/setup/billing">{{ 'yearly_billing.details.back_to_overview' | translate}}</button></p>
        </div>
    </div>
</div>

